/** Narrowing guards for values read as `unknown` (parsed JSON, error payloads, stored settings). */

/** An array whose every item is a string; an empty array is one. */
export const isStringArray = (value: unknown): value is string[] => Array.isArray(value) && value.every((item) => typeof item === "string");
